import { render, staticRenderFns } from "./AccountTransportLayout.vue?vue&type=template&id=19ebcc24&scoped=true"
import script from "./AccountTransportLayout.vue?vue&type=script&lang=js"
export * from "./AccountTransportLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ebcc24",
  null
  
)

export default component.exports